import React from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  FetchRegionList,
  DeleteRegionRecord,
} from "../../../services/locationService";
import { useState, useEffect, useRef } from "react";

import serach_icon from "../../../assets/images/icon/search-icon.svg";
import dowanload_csv from "../../../assets/images/icon/downloadcsv.svg";

import delete_icon from "../../../assets/images/icon/delete.svg";
import edit_icon from "../../../assets/images/icon/edit.svg";

import arrow_btn from "../../../assets/images/icon/arrow-btn.svg";
import right_arrow from "../../../assets/images/icon/right-arrow-table.svg";

import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import { Button } from "reactstrap";
import { downloadCSVReport } from "helpers/backend_helper";
import { getUserInfo } from "helpers/authHelper";
import { checkPermissionStatus } from "helpers/utils";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";

function MasterRegion(props) {
  const { t } = useTranslation();
  const [regionData, setregionData] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const userInfo = getUserInfo();

  //tabs
  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  const [csvData, setCSVData] = useState([]);

  const handleCSVDownload = async e => {
    e.preventDefault();

    if (regionData?.length === 0) {
      toast.error(t(`Location_Manager.No data available`));
      return;
    }

    let allData = JSON.parse(JSON.stringify(regionData)) || [];
    allData = allData?.map(el => {
      el.statusText = el?.status === 1 ? "Active" : "Inactive";
      return el;
    });

    try {
      setCSVData(allData || []);
      setTimeout(() => {
        let element = document.getElementById("downloadCSV");
        element.click();
      }, 1000);
    } catch (err) {}
  };

  useEffect(() => {
    getRegionList();
    document.title = "NeuroTal - Region List";
  }, []);

  const getRegionList = async () => {
    FetchRegionList()
      .then(res => {
        let response = decryptDataFromArray(res.data);

        if (response.status) {
          let data = response.data;
          // data = data.filter(item => item.status === 1);
          setregionData(data);
        } else {
          toast.error(t(`Location_Manager.No data available`));
        }
      })
      .catch(err => {
        toast.error(t(`Location_Manager.No data available`));
      });
  };

  // Bootstrap table columns
  const handleCheck = (e, app_id) => {
    let value = e.target.checked;
    let allRegions = regionData?.map(el => {
      if (el?.region_id === app_id) {
        el.checked = value;
      }
      return el;
    });
    setregionData(allRegions);
  };
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  let columns = [
    // {
    //   dataField: "region_id",
    //   text: "Region Id",
    //   classes: "total",
    //   formatter: (cellContent, row) => {
    //     return <div className="date-tabel">
    //       {/* <input
    //         defaultChecked={row?.checked || false}
    //         onClick={(e) => handleCheck(e, row?.id)}
    //         type="checkbox" /> */}
    //       <label>
    //         {row.id}
    //       </label>
    //     </div>
    //       ;
    //   },
    // },

    {
      dataField: "serial_no",
      text: t(`Location_Manager.Serial No`),
      formatter: (cellContent, row, rowIndex) => {
        return rowIndex + 1; // Serial number starts from 1
      },
    },

    {
      dataField: "region",
      text: t(`Location_Manager.Region Name`),
      classes: "region-name mobile-city",
    },
    {
      dataField: "status",
      text: t(`Location_Manager.Status`),
      classes: "region-status mobile-city",
      formatter: (cell, row) => {
        return cell === 1
          ? t(`Location_Manager.Active`)
          : t(`Location_Manager.Inactive`);
      },
    },
  ];

  if (checkPermissionStatus("region-list", "edit")) {
    columns.push({
      dataField: "",
      text: t(`Location_Manager.Actions`),
      formatter: (cell, row) => {
        let region_id = row.id;
        return (
          <>
            <div className="d-flex gap-1 blue-icon-gap action-application">
              <div className="action-one small-img">
                <Link
                  className="text-success blue-icon blue-color4"
                  to={`/edit-region/${region_id}`}
                  // title="Edit Region"
                >
                  <img src={edit_icon} alt="edit_icon" />
                  <span>{t(`Location_Manager.Edit Region`)}</span>
                </Link>
              </div>

              {/* <div className="action-one small-img">
                <Link
                  to="#"
                  onClick={() => handleRejectedRecords(region_id)}
                  className="blue-color3"
                >
                  <img src={delete_icon} alt="delete_icon" />
                  <span>{t(`Location_Manager.Delete`)}</span>
                </Link>
              </div> */}
            </div>
          </>
        );
      },
    });
  }

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Location_Manager.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "Next page",
    prePageTitle: "Pre page",
    firstPageTitle:"First page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };
  // Delete Faqs
  const handleRejectedRecords = region_id => {
    DeleteRegionRecord(region_id)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        if (res?.status == 200) {
          let messages = toast.success(responseData?.message);
          getRegionList();
          // window.location.reload();
        } else {
          toast.error(responseData?.message);
          ref.current?.scrollIntoView({ behavior: "smooth" });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  //rohit-code//

  const options2 = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
    totalSize: regionData.length,
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  const renderCheck = el => {
    if (!query) {
      return true;
    }
    let searchItem = JSON.stringify(el)?.toLowerCase();
    if (searchItem?.includes(query?.toLowerCase())) {
      return true;
    }
    return false;
  };

  

  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  if (!checkPermissionStatus("region-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Location_Manager.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <>
      <div className="pending-list-page feedbacks departmentpage">
        <div className="tab-content" id="pills-tabContent">
          <div className="joblist-container create-vacancy main-pages-s">
            <Row className="mb-2 align-items-center">
              <Col lg="6" md="6" className="Joblist-column">
                <Link to="/dashboard">
                  <h5 className="text-uppercase heading-one">
                    <img src={arrow_btn} alt="arrow_btn" />
                    {t(`Location_Manager.Region List`)}
                  </h5>
                </Link>
              </Col>
            </Row>
          </div>

          <div className="outerTab-box-wrapper below-vacancy  amsterresign  applicationcard-table">
            <div className="region-list-page aploc">
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  // aria-labelledby="pills-home-tab"
                >
                  <div className="tabel-application tabel-application-auto  tabel-region table-responsive pb-3">
                    <div className="table-data-search frenchise-list mt-0">
                      <div className="total-record">
                        <h5>
                          {t(`Location_Manager.Total Records`)}{" "}
                          <span>{regionData?.length || 0}</span>
                        </h5>
                      </div>
                      <div className="total-serachbar">
                        <div className="serach-bar-top">
                          <form className="form-inline">
                            <input
                              className="form-control mr-sm-2"
                              type="search"
                              placeholder={t(
                                `Location_Manager.Search by Region`
                              )}
                              aria-label="Search"
                              value={query}
                              onChange={e => setQuery(e.target.value)}
                              // title={`Please enter ${t(
                              //   `Location_Manager.Search by Region`
                              // ).toLowerCase()}`}
                              title={t(`Location_Manager.Search by Region`)}
                            />
                            <span>
                              <img src={serach_icon} alt="search" />
                            </span>
                          </form>
                        </div>
                        {/*<div className="take-text">
                      <h5>Send CSV via Mail</h5>
                    </div>*/}
                        {checkPermissionStatus(
                          "region-list",
                          "downloadcsv"
                        ) && (
                          <div className="take-text">
                            <CSVLink
                              data={csvData}
                              headers={[
                                {
                                  key: "id",
                                  label: t(`Location_Manager.Region ID`),
                                },
                                {
                                  key: "region",
                                  label: t(`Location_Manager.Region Name`),
                                },
                                {
                                  key: "statusText",
                                  label: t(`Location_Manager.Status`),
                                },
                              ]}
                              filename={`regionList.csv`}
                              id="downloadCSV"
                            >
                              <Button
                                color="info"
                                onClick={e => handleCSVDownload(e)}
                                outline
                              >
                                <img src={dowanload_csv} alt="Download" />{" "}
                                {t(`Location_Manager.Download CSV`)}
                              </Button>
                            </CSVLink>
                          </div>
                        )}

                        {checkPermissionStatus("region-list", "create") && (
                          <Link to="/create-region" className="btn btn-primary">
                            {t(`Location_Manager.Create Region`)}
                          </Link>
                        )}

                        <div className="tale-text right-panel mobile-arrow mb-0">
                          <button
                            className="button left"
                            onClick={() => handleScroll("left")}
                            data-tooltip="Scroll Left"
                          >
                            <img src={right_arrow} alt="right-arrow" />
                          </button>
                          <button
                            className="button right"
                            onClick={() => handleScroll("right")}
                            data-tooltip="Scroll Right"
                          >
                            <img src={right_arrow} alt="right-arrow" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="timeto-hire-card userlist pendiglist-cardss">
                      <div className="table-custome-class range-custome">
                        <div className="scroll-container">
                          <div className="table-pending-list">
                            {regionData?.length > 0 && (
                              <div
                                className="table-wrapper"
                                ref={tableWrapperRef}
                              >
                                <BootstrapTable
                                  keyField="id"
                                  data={regionData?.filter(renderCheck)}
                                  columns={columns}
                                  pagination={paginationFactory(options)}
                                  rowClasses={rowClasses}
                                  hover
                                  responsive
                                />
                              </div>
                            )}

                            {regionData?.length === 0 && (
                              <>
                                <div className="no-data data-available">
                                  <img
                                    src="../img/data-not-available.png"
                                    alt="data not availble"
                                  />
                                  <h3>
                                    {" "}
                                    {t(`Location_Manager.No Item Found`)}
                                  </h3>
                                  <p>
                                    {t(
                                      `Location_Manager.Sorry, we could not find any`
                                    )}
                                    <br />{" "}
                                    {t(`Location_Manager.Item to show here`)}
                                  </p>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MasterRegion;
